import { RootState } from '@/store';

export const selectAuthTokenVerification = (state: RootState) => state.authToken.tokenVerification;
export const selectAuthTokenQueryState = (state: RootState) => state.authToken.queryState;
export const selectAuthTokenError = (state: RootState) => state.authToken.error;
export const selectAuthToken = (state: RootState) => state.authToken.token;
export const selectSessionExpiration = (state: RootState) => state.authToken.tokenExpiresAt;
export const accessTypeSelector = (state: RootState) => state.authToken.accessType;
export const userIDSelector = (state: RootState) => state.authToken.userId;
